<template>
  <div>
    <v-navigation-drawer
      v-model="$store.state.drawer"
      disable-route-watcher
      persistent
      overflow
      fixed
      app
    >
      <!-- Logged in user display -->
      <v-toolbar flat class="transparent">
        <v-list class="pa-0" v-if="loggedIn">
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <img v-img-orientation-changer :src="user.avatar" class="elevation-2" />
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ fullName }}</v-list-tile-title>
              <v-list-tile-sub-title v-if="organization && organization.id">
                {{ organization.name }}
              </v-list-tile-sub-title>
              <v-list-tile-sub-title v-else-if="role">{{ role.capitalize() }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>

      <!-- Navigation options for user role -->
      <Candidate v-if="role === 'candidate'" :location="location" @logOut="logOut" />
      <Client v-if="role === 'client'" @logOut="logOut" />
    </v-navigation-drawer>
  </div>
</template>

<script>
// Components
import Client from '@/components/client/Navigation'
import Candidate from '@/components/candidate/Navigation'

// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  components: { Candidate, Client },
  props: { location: { type: Object, default: null } },
  created() {
    this.$store.dispatch('client/chats/fetchAll')
  },
  computed: {
    ...mapGetters({
      loggedIn: 'auth/loggedIn',
      fullName: 'auth/fullName',
      user: 'auth/user',
      role: 'auth/role',
      organization: 'client/organization/model',
    }),
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logOut')
      this.$store.commit('closeDrawer')
      this.$router.push('/')
    },
  },
}
</script>
